import Page from "components/common/page/Page";
import PersonForm from "components/entities/app/person/PersonFrom";
import { AppRoutes } from "config/router";
import { useParams } from "react-router-dom";
import { PersonType } from "types/person-types";
import useAppNavigate from "utilities/hooks/useAppNavigate";

type PersonFormPageUrlParamsType = {
    id?: string
}

const PERSON_FORM_NAME = "person-form-page-form";

const PersonFormPage = () => {
    const params = useParams<PersonFormPageUrlParamsType>();
    const navigate = useAppNavigate();
    const onSubmit = (person?: PersonType) => {
        if (person?.id) {
            navigate(AppRoutes.PERSON_VIEW, {id: person.id});
        }
    }

    return (
        <Page title="pages.people.form">
            <PersonForm
                name={PERSON_FORM_NAME}
                formId={PERSON_FORM_NAME}
                model={params.id}
                onSubmit={onSubmit}
            />
        </Page>
    );
};

export default PersonFormPage;
